<template>
    <span class="urge-info-time">
        <span>距活动结束</span><span class="urge-info-number">{{timeText}}<span class="millisecond">{{milliTimeText}}</span></span>
    </span>
</template>
<script>
export default {
    props: {
        // 剩余时间,毫秒
        remainingTime: {
            type: Number,
            default() {
                return 0;
            }
        },
        baseTimestamp: {
            type: Number,
            default() {
                return 0;
            }
        }
    },
    data() {
        return {
            timeText: '',
            milliTimeText: '',
            counting: false
        };
    },
    watch: {
        remainingTime: {
            handler(val, oldVal) {
                this.startCountDown();
            },
            immediate: true
        }
    },
    beforeCreate() {
        this.endTime = 0;
    },
    beforeDestroy() {
        if (this.requestAnimationId) {
            window.cancelAnimationFrame(this.requestAnimationId);
            this.requestAnimationId = 0;
        }
    },
    methods: {
        startCountDown() {
            if (this.counting) {
                return;
            }
            this.counting = true;
            this.endTime = this.baseTimestamp + this.remainingTime;
            this.countDown();
        },
        countDown() {
            const currentTime = Date.now();
            if (currentTime >= this.endTime) {
                this.counting = false;
                this.timeText = '00:00:00.';
                // 如果重新请求接口返回数据不变,需要手动触发重新倒计时
                this.$store.dispatch('course/GET_PROMOTION_DETAIL', {
                    config: {
                        disableLoading: true
                    }
                }).then(() => {
                    this.startCountDown();
                });
                return;
            }
            this.formatTimeText(this.endTime - currentTime);
            this.requestAnimationId = window.requestAnimationFrame(this.countDown);
        },
        formatTimeText(milliseconds) {
            const hour = Math.floor(milliseconds / 3600 / 1000);
            milliseconds = milliseconds - hour * 3600 * 1000;
            const minute = Math.floor(milliseconds / 60 / 1000);
            milliseconds = milliseconds - minute * 60 * 1000;
            const second = Math.floor(milliseconds / 1000);
            milliseconds = milliseconds - second * 1000;
            const millisecond = Math.floor(milliseconds / 100);

            const hourStr = this.formatTimeTextUnit(hour);
            const minuteStr = this.formatTimeTextUnit(minute);
            const secondStr = this.formatTimeTextUnit(second);

            this.timeText = `${hourStr}:${minuteStr}:${secondStr}.`;
            this.milliTimeText = millisecond;
        },
        formatTimeTextUnit(time) {
            const timeLen = time.toString().length;
            return timeLen >= 2 ? time : '0'.repeat(2 - timeLen) + time;
        }
    }
};
</script>
<style lang="less">
.urge-info-time {
    // 使用等宽字体保证数字变更时不会发生抖动
    .urge-info-number,
    .millisecond {
        font-variant-numeric: tabular-nums;
        font-family: arial, Helvetica, sans-serif;
    }
}
</style>
